import React, { Fragment } from 'react';
import * as Actions from 'asset_level/components/list/actions';

const AssetLevelActions = ({ company, subcompany, permissions, asset_level, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.asset_level.toggle'] && (
        <Actions.Toggle asset_level={asset_level} handleClick={handleToggle} />
      )}

      {permissions['acl.asset_level.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          asset_level={asset_level}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default AssetLevelActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/AssetLevelActions.js